import { Paper, SxProps, Theme } from '@mui/material'
import { ReactNode } from 'react'

type PageContainerProps = {
    children: ReactNode
    sx?: SxProps<Theme>
}

const PageContainer = ({ children, sx }: PageContainerProps) => {
    return (
        <Paper 
            elevation={0} 
            sx={{ 
                p: { xs: 2, md: 3 }, 
                borderRadius: 3, 
                boxShadow: '0px 8px 24px rgba(15,15,15,0.06)',
                ...sx
            }}>
            {children}
        </Paper>
    )
}

export default PageContainer

